const { VARIANTS } = require('../../types/variants');

const isExperimentVariation = (variation) => variation >= VARIANTS.B;

const isInExperimentGroup = (experimentId, experimentGroups = [], abTests = {}) => !!abTests[experimentId] && experimentGroups.includes(abTests[experimentId]);

const inExperiment = (experimentId, abTests = {}) => {
    const variation = getVariation(experimentId, abTests);

    return isExperimentVariation(variation);
};

const getVariation = (experimentId, abTests = {}) => {
    const variation = abTests[experimentId];

    return transformVariation(variation);
};

const isAllocated = (experimentId, abTests = {}) => {
    const variation = Number(abTests[experimentId]);

    return variation >= VARIANTS.A;
};

const transformVariation = (variation) => {
    switch (Number(variation)) {
        case 1:
            return VARIANTS.A;
        case 2:
            return VARIANTS.B;
        case 3:
            return VARIANTS.C;
        default:
            return VARIANTS.A;
    }
};

module.exports = {
    isExperimentVariation,
    inExperiment,
    getVariation,
    isAllocated,
    isInExperimentGroup
};
